import { omit } from "lodash";
import { handleActions } from "redux-actions";
import { BuildingId, BuildingOrg } from 'shared/models';
import { Actions, getBuildingSuccess, createBuildingSuccess, deleteBuildingSuccess, getBuildingsSuccess, buildingFetched } from 'actions/buildingActions';
import { Actions as SessionActions } from 'actions/sessionActions';

export type State = Readonly<{
    data: Record<BuildingId, BuildingOrg[]>;
}>;

export const initialState = Object.freeze<State>({
    data: {},
});


export const buildingOrgsReducer = handleActions({
    [Actions.CREATE_BUILDING_SUCCESS]: (state: State, action: ReturnType<typeof createBuildingSuccess>) => {
        const { buildingOrg } = action.payload;
        if (!buildingOrg) return state;
        const { data } = state;
        return {
            ...state,
            data: {
                ...data,
                [buildingOrg.buildingId]: [
                    buildingOrg,
                ],
            },
        };
    },

    [Actions.GET_BUILDINGS_SUCCESS]: (state: State, action: ReturnType<typeof getBuildingsSuccess>) => {
        const { buildingOrgs } = action.payload;
        const { data } = state;
        return {
            ...state,
            data: {
                ...data,
                ...buildingOrgs,
            },
        };
    },

    [Actions.GET_BUILDING_SUCCESS]: (state: State, action: ReturnType<typeof getBuildingSuccess>) => {
        const { building, buildingOrgs } = action.payload;
        const { data } = state;
        return {
            ...state,
            data: {
                ...data,
                [building.id]: buildingOrgs,
            },
        };
    },

    [Actions.BUILDING_FETCHED]: (state: State, action: ReturnType<typeof buildingFetched>) => {
        const { building, buildingOrgs } = action.payload;
        const { data } = state;
        return {
            ...state,
            data: {
                ...data,
                [building.id]: buildingOrgs,
            },
        };
    },

    [Actions.DELETE_BUILDING_SUCCESS]: (state: State, action: ReturnType<typeof deleteBuildingSuccess>) => {
        const { id } = action.meta;
        return {
            ...state,
            data: omit(state.data, id),
        };
    },


    //
    //  Session Actions
    //
    [SessionActions.LOGOUT_SUCCESS]: () => {
        return initialState;
    },
} as any, initialState);
